import { getBreakpointFromWidth, getColsFromBreakpoint } from "react-grid-layout";
import type { Breakpoint, BreakpointConfig } from "./dashboard.types";

export const BREAKPOINT_CONFIGS: BreakpointConfig[] = [
    { breakpoint: "lg", cols: 12, minWidth: 1200 },
    { breakpoint: "md", cols: 12, minWidth: 996 },
    { breakpoint: "sm", cols: 6, minWidth: 768 },
];

export const BREAKPOINTS = BREAKPOINT_CONFIGS.map((c) => c.breakpoint);

export const RGL_BREAKPOINTS: Record<Breakpoint, number> = Object.fromEntries(
    BREAKPOINT_CONFIGS.map((c) => [c.breakpoint, c.minWidth]),
) as Record<Breakpoint, number>;

export const RGL_COLS: Record<Breakpoint, number> = Object.fromEntries(
    BREAKPOINT_CONFIGS.map((c) => [c.breakpoint, c.cols]),
) as Record<Breakpoint, number>;

const SMALLEST_BREAKPOINT = BREAKPOINT_CONFIGS[BREAKPOINT_CONFIGS.length - 1];

export const GRID_MIN_WIDTH = SMALLEST_BREAKPOINT.minWidth;

export function getCurrentBreakpoint(width: number): Breakpoint {
    return getBreakpointFromWidth(RGL_BREAKPOINTS, width);
}

export function getColsForBreakpoint(breakpoint: string): number {
    if (!isBreakpoint(breakpoint)) return SMALLEST_BREAKPOINT.cols;
    return getColsFromBreakpoint(breakpoint, RGL_COLS);
}

export function getColsForWidth(width: number): number {
    return getColsForBreakpoint(getCurrentBreakpoint(width));
}

export function isBreakpoint(value: string): value is Breakpoint {
    return BREAKPOINTS.some((breakpoint) => breakpoint === value);
}
